import React from 'react';
import {Typography, Box, BoxProps, CircularProgress} from '@mui/material';
import {newUTCDate} from '../../utils/newUTCDate';

const RandomImage = () => {
  const anyNumber = newUTCDate().getDay() % 3;
  if (anyNumber === 0) {
    return <img src="/piggy.gif" alt="piggy" width={75} height={55} />;
  }
  if (anyNumber === 1) {
    return <img src="/bg.gif" alt="piggy" width={75} height={52} />;
  }
  return <img src="/car.gif" alt="piggy" width={75} height={45} />;
};

const loadingEllipsis = {
  '&:after': {
    overflow: 'hidden',
    display: 'inline-block',
    verticalAlign: 'bottom',
    animation: 'ellipsis 1s linear 1s infinite',
    content: "'\u2026'",
    width: '0px',
    marginRight: '1.25em',
  },
  '@keyframes ellipsis': {
    to: {
      marginRight: '0px',
      width: '1.25em',
    },
  },
};

const Loading: React.FC<BoxProps & {entityName?: string; spinner?: boolean}> = ({
  entityName = '',
  children,
  spinner = false,
  ...props
}) => {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" {...props}>
      {spinner ? (
        <CircularProgress color="primary" />
      ) : (
        <div
          style={{
            backgroundImage:
              'radial-gradient(rgba(0,0,0,.2), rgba(0,0,0,0), rgba(0,0,0,0))',
          }}
        >
          <RandomImage />
        </div>
      )}
      <Box mt={2} />
      {children ? (
        <Typography color="textPrimary" variant="h6" sx={loadingEllipsis}>
          {children}
        </Typography>
      ) : (
        <Typography color="textPrimary" variant="h6" sx={loadingEllipsis}>
          <span>Loading {entityName}</span>
        </Typography>
      )}
    </Box>
  );
};

export default Loading;
